import { z } from 'zod';
import { matrixAdapterGreengrassComponentName } from './greengrass-component-names.js';
import { GatewayAdapterKeySchema, toThingGroupSuffix } from './gateway-adapter-common.js';

export const LocationAdapterKeySchema = GatewayAdapterKeySchema;
export type LocationAdapterKey = z.infer<typeof LocationAdapterKeySchema>;

export { toThingGroupSuffix };

export type LocationSystemType = 'uwb' | 'ble';

export interface LocationAdapterRegistryEntry {
  locationAdapterKey: LocationAdapterKey;
  systemType: LocationSystemType;
  displayName: string;
  greengrassComponentName: string;
  thingGroupSuffix: string;
  /** Default install path on Windows edge PC */
  defaultInstallPath: string;
  isDevSimulator?: boolean;
}

export const LOCATION_ADAPTER_REGISTRY: readonly LocationAdapterRegistryEntry[] = [
  {
    locationAdapterKey: 'woxu-ls1000',
    systemType: 'uwb',
    displayName: 'Woxu LS-1000 UWB Location Engine',
    greengrassComponentName: matrixAdapterGreengrassComponentName('woxu-ls1000'),
    thingGroupSuffix: toThingGroupSuffix('woxu-ls1000'),
    defaultInstallPath: 'C:\\Cnapse\\LS1000-location-engine',
  },
];

const REGISTRY_BY_KEY = new Map(
  LOCATION_ADAPTER_REGISTRY.map((e) => [e.locationAdapterKey, e] as const),
);

export function getLocationAdapterRegistryEntry(locationAdapterKey: string): LocationAdapterRegistryEntry {
  const key = LocationAdapterKeySchema.parse(locationAdapterKey);
  const found = REGISTRY_BY_KEY.get(key);
  if (!found) {
    throw new Error(`Unknown locationAdapterKey: ${key}`);
  }
  return found;
}

export function listLocationAdapterRegistryEntries(): LocationAdapterRegistryEntry[] {
  return [...LOCATION_ADAPTER_REGISTRY];
}

export function getSystemTypeForLocationAdapter(locationAdapterKey: string): LocationSystemType {
  return getLocationAdapterRegistryEntry(locationAdapterKey).systemType;
}
